<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">list_alt</span>
      <p>
        Registra los servicios y recursos utilizados en la atención: exámenes
        de laboratorio, imágenes diagnósticas, procedimientos y cualquier otro
        elemento del tarifario de la empresa. Muestra el total facturado al
        pie de la tabla.
      </p>
    </div>

    <!-- Cómo funciona -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Cómo funciona
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in flujo" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Tipos de elementos -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">category</span>
        Tipos de elementos del tarifario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in tipos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Campos del formulario -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">edit_note</span>
        Campos del formulario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in campos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Restricción por estado -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">lock</span>
        Restricciones por estado de la atención
      </h3>
      <div class="help-estados" style="margin-bottom:0.5rem">
        <span class="help-estado-badge" style="background:#fff3cd;color:#856404">PENDIENTE</span>
        <span class="help-estado-badge" style="background:#cce5ff;color:#004085">PROCESO</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem">
        Editar y eliminar elementos solo está disponible cuando la atención
        está en estado <strong>PENDIENTE</strong> o <strong>PROCESO</strong>.
        Agregar nuevos elementos está siempre habilitado
        independientemente del estado.
      </p>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Al seleccionar un elemento del tarifario, el precio unitario y la
        cantidad se completan automáticamente con los valores configurados
        para la empresa. Puedes ajustarlos manualmente antes de guardar.
        El <strong>Total</strong> al pie de la tabla suma todos los registros,
        no solo la página visible.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaAtencionDet",
  data() {
    return {
      flujo: [
        {
          icon: "add_circle",
          titulo: "Agregar elemento",
          desc:   "Pulsa el botón Nueva para abrir el formulario. Busca el elemento del tarifario, ajusta el precio y la cantidad, y guarda el registro.",
        },
        {
          icon: "table_rows",
          titulo: "Lista de elementos",
          desc:   "La tabla muestra todos los servicios y recursos registrados con su código, descripción, cantidad, precio unitario y precio total calculado.",
        },
        {
          icon: "calculate",
          titulo: "Total automático",
          desc:   "El total al pie de la tabla se calcula sumando cantidad × precio unitario de todos los registros de la atención.",
        },
      ],
      tipos: [
        {
          icon: "biotech",
          titulo: "Laboratorio",
          desc:   "Exámenes de laboratorio clínico: biometría hemática, química sanguínea, urianálisis, cultivos y otros análisis de muestras biológicas.",
        },
        {
          icon: "radiology",
          titulo: "Imagen",
          desc:   "Estudios de diagnóstico por imagen: radiografías, ecografías, tomografías, resonancias magnéticas y otros.",
        },
        {
          icon: "medical_services",
          titulo: "Procedimientos",
          desc:   "Intervenciones y procedimientos clínicos realizados durante la atención: curaciones, suturas, inyecciones, nebulizaciones y similares.",
        },
        {
          icon: "medication",
          titulo: "Medicamentos e insumos",
          desc:   "Fármacos y materiales médicos utilizados o administrados durante la atención.",
        },
      ],
      campos: [
        {
          icon: "search",
          titulo: "Elemento (buscador)",
          desc:   "Escribe parte del código o nombre del elemento para filtrar el catálogo del tarifario de la empresa. Presiona Enter o haz clic en el botón para desplegar la lista. Selecciona el elemento para asignarlo.",
        },
        {
          icon: "attach_money",
          titulo: "Precio unitario",
          desc:   "Se completa automáticamente con el precio configurado para el elemento en la empresa. Puede ajustarse manualmente. No puede ser negativo.",
        },
        {
          icon: "pin",
          titulo: "Cantidad",
          desc:   "Número de unidades del elemento utilizado. Se inicializa en 1 al seleccionar un elemento. No puede ser negativa.",
        },
      ],
      acciones: [
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nuevo",
          desc:   "Abre el formulario para agregar un elemento del tarifario a la atención. Disponible en cualquier estado.",
        },
        {
          icon:   "edit",
          color:  "#198754",
          titulo: "Editar",
          desc:   "Permite modificar el precio unitario o la cantidad del elemento registrado. El campo de búsqueda se precarga con el código y nombre del elemento. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Eliminar",
          desc:   "Elimina el elemento de la atención de forma permanente. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
        {
          icon:   "refresh",
          color:  "#6c757d",
          titulo: "Recargar",
          desc:   "Recarga la lista de elementos registrados para la atención actual.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>